// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M4.25 8H8.25C10.45 8 11.75 8.95 11.75 10.5C11.75 12.05 10.45 13 8.25 13H4.75C4.47 13 4.25 12.78 4.25 12.5V3.5C4.25 3.22 4.47 3 4.75 3H7.9C9.95 3 11.1 3.95 11.1 5.5C11.1 7.05 9.95 8 8.25 8',
];
